import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

const PUBLIC_ROUTES = ["/LoginNumber", "/LoginCode", "/LoginPassword", "/SetPassword"];

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  const isPublicRoute = PUBLIC_ROUTES.some((route) => location.pathname.startsWith(route));

  if (!isAuthenticated && !isPublicRoute) {
    return <Navigate to="/LoginNumber" replace state={{ from: location }} />;
  }

  return children;
}

export default ProtectedRoute;
